import i18n from '@/i18n'
import { pickBy } from '@/utils'
import AttrItem from './attr-item'

export default {
  name: 'slider',
  setting: [
    { label: i18n.t('wgt_slider.config.418485-0'), key: 'title', component: 'input', value: i18n.t('wgt_slider.config.418485-1') },
    { label: i18n.t('wgt_slider.config.418485-2'), key: 'subtitle', component: 'input', value: i18n.t('wgt_slider.config.418485-3') },
    // { label: '标题颜色', key: 'WordColor', component: 'color', value: '#333333' },
    {
      label: i18n.t('wgt_slider.config.418485-4'),
      key: 'interval',
      component: 'number',
      value: 3000,
      min: 1000,
      max: 50000,
      step: 1000
    },
    { label: i18n.t('wgt_slider.config.418485-5'), key: 'padded', component: 'switch', value: true },
    { label: i18n.t('wgt_slider.config.418485-6'), key: 'rounded', component: 'switch', value: false },
    {
      label: i18n.t('wgt_slider.config.418485-7'),
      key: 'dot',
      component: 'radio',
      options: [
        { name: i18n.t('wgt_slider.config.418485-8'), label: true },
        { name: i18n.t('wgt_slider.config.418485-9'), label: false }
      ],
      value: true
    },
    { label: i18n.t('wgt_slider.config.418485-10'), key: 'dotCover', component: 'switch', value: false },
    {
      label: i18n.t('wgt_slider.config.418485-11'),
      key: 'dotLocation',
      component: 'radio',
      options: [
        { name: i18n.t('wgt_slider.config.418485-12'), label: 'left' },
        { name: i18n.t('wgt_slider.config.418485-13'), label: 'center' },
        { name: i18n.t('wgt_slider.config.418485-14'), label: 'right' }
      ],
      value: 'right'
    },
    {
      label: i18n.t('wgt_slider.config.418485-15'),
      key: 'shape',
      component: 'radio',
      options: [
        { name: i18n.t('wgt_slider.config.418485-16'), label: 'circle' },
        { name: i18n.t('wgt_slider.config.418485-17'), label: 'rectangle' }
      ],
      value: 'circle'
    },
    {
      label: i18n.t('wgt_slider.config.418485-18'),
      key: 'dotColor',
      component: 'radio',
      options: [
        { name: i18n.t('wgt_slider.config.418485-19'), label: 'dark' },
        { name: i18n.t('wgt_slider.config.418485-20'), label: 'light' }
      ],
      value: 'dark'
    },
    { label: i18n.t('wgt_slider.config.418485-21'), key: 'itemPadded', component: 'switch', value: true },
    // { label: '图片描述', key: 'content', component: 'switch', value: true },
    {
      label: i18n.t('wgt_slider.config.418485-22'),
      key: 'data',
      component: function (h, { key }) {
        return <AttrItem v-model={this.value[key]} />
      },
      value: [
        {
          button: '',
          content: '',
          id: '',
          imgUrl: '',
          linkPage: '',
          mainTitle: '',
          subtitle: '',
          subtitleTow: '',
          template: ''
        }
      ]
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data } = v
    return {
      name,
      ...base,
      ...config,
      data
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      config: (v) => {
        return pickBy(v, {
          interval: 'interval',
          dot: 'dot',
          dotLocation: 'dotLocation',
          dotColor: 'dotColor',
          shape: 'shape',
          dotCover: 'dotCover',
          rounded: 'rounded',
          content: 'content'
        })
      },
      data: 'data'
    })
  }
}
